import { Router } from "router";
import { useEffect, useState } from "react";
import { applyColorPaletteToDOM } from "theme";
import { useStartUp } from "hooks";
import { SplashLoading } from "components";
import { ToastContainer, Slide } from "react-toastify";

import "react-toastify/dist/ReactToastify.min.css";

function App() {
  useStartUp();

  const [splashLoadingOpen, setSplashLoadingOpen] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSplashLoadingOpen(false);
    }, 3000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    applyColorPaletteToDOM();
  }, []);

  return (
    <div className="mx-auto max-w-md min-h-screen bg-[#EFEFEF]">
      <Router />
      <ToastContainer
        rtl
        limit={1}
        position="top-center"
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        pauseOnHover={true}
        theme="colored"
        closeButton={false}
        transition={Slide}
        style={{ padding: 0 }}
        bodyStyle={{ padding: 0, justifyContent: "center" }}
        toastStyle={{
          padding: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      />
      <SplashLoading open={splashLoadingOpen} />
    </div>
  );
}

export default App;
